import TrainingTea from './TrainingTea.vue'

export default TrainingTea
